import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeResponseDto } from '../../../store/landscapeAPI/theme/dto/response/theme-response.dto';
import { Action, Label, TableRow } from '../../atoms';
import { SortableTable } from '../../molecules';

//import styles from './ReportingDetailsThemesOrganism.module.css';

interface ReportingDetailsThemesOrganismProps {
  data: ThemeResponseDto[];
  handleDeleteTheme: (id: string) => void;
}

const ReportingDetailsThemesOrganism: FC<
  ReportingDetailsThemesOrganismProps
> = ({ data, handleDeleteTheme }) => {
  const navigate = useNavigate();

  const handleUpdateTheme = (id: string) => {
    navigate(`/reporting-details/themes/${id}/edit`);
  };

  return (
    <SortableTable
      data={data}
      columns={[{ label: 'Themes', key: 'name' }]}
      renderRow={(row) => (
        <TableRow key={row.id}>
          <Label content={row.name}></Label>
          <Action
            type="edit"
            size="sm"
            onClick={() => handleUpdateTheme(row.id)}
          />
          <Action
            type="delete"
            size="sm"
            onClick={() => handleDeleteTheme(row.id)}
          />
        </TableRow>
      )}
    />
  );
};

export default ReportingDetailsThemesOrganism;
